export default {
    delivery: {
        product: {
            tracking: "Monitoraggio",
            quantity: "Quantità"
        }
    }
}